module.exports = __webpack_public_path__ + "img/cloud1.442a93db.png";